import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import {store} from './store/index'

import Api from './api/index'

Vue.use(Router)

function requirePermission (to, from, next) {
  // console.log(store.state.User.oneUser);
  // console.log(The_Ability.can('read', 'Proposal'));
  if (The_Ability.can(to.meta.permission.act, to.meta.permission.on)) next()
  else {
    if (store.state.User.oneUser == null){
      Api.User.profile()
        .then(response => response.data)
        .then(user=>{
          const ability = new Ability()
          ability.update(user.data.attributes.roles[0].permissions.can)
          // console.log(ability.can('read','Proposal'));
          if (ability.can(to.meta.permission.act, to.meta.permission.on)) next()
          else next(from.fullPath)
        })
    } else {
      next(from.fullPath)
    }
  }
}

function checkUser(to, from, next){
  if (store.state.User.oneUser){
    // console.log('has user');
    next(from.fullPath)
  } else {
    Api.User.profile()
      .then(response => response.data)
      .then(user=>{
        if (user){
          // console.log('really has user - ' +user);
          next(from.fullPath)
        } else {
          // console.log('go to login');
          next()
        }
      }).catch( function(error) {
        // console.log('error, go to login');
        console.log({error_in_profile_router_guard: error});
        next()
      });
  }
}



const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('./components/auth/Login.vue'),
      beforeEnter: checkUser,
    },
    {
      path: '/logout',
      name: 'Logout',
      meta: {
        auth: true,
      },
      component: () => import('./components/auth/Logout.vue')
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        auth: true,
      },
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Help.vue')
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: {
        auth: true,
      },
      component: () => import('./views/Profile.vue')
    },
    {
      // talvez nao tenha
      path: '/clients',
      name: 'Clients',
      meta: {
        auth: true,
      },
      component: () => import('./views/Clients.vue')
    },
    {
      // talvez nao tenha
      path: '/clients/new',
      name: 'ClientNew',
      meta: {
        auth: true,
      },
      component: () => import('./components/clients/ClientNew.vue')
    },
    {
      // talvez nao tenha
      path: '/clients/show/:id',
      name: 'ClientShowProfile',
      meta: {
        auth: true,
      },
      component: () => import('./components/clients/ClientShowProfile.vue')
    },
    {
      // talvez nao tenha
      path: '/clients/edit/:id',
      name: 'ClientEditProfile',
      meta: {
        auth: true,
      },
      component: () => import('./components/clients/ClientEditProfile.vue')
    },
    // {
    //   // talvez nao tenha
    //   path: '/clients/:id/edit',
    //   name: 'ClientProfile',
      // meta: {
      //   auth: true,
      // },
    //   component: () => import('./components/clients/ClientProfile.vue')
    // },
    {
      path: '/suppliers',
      name: 'Suppliers',
      meta: {
        // auth: true,
      },
      component: () => import('./views/Suppliers.vue')
    },
    {
      path: '/bills',
      name: 'Bills',
      meta: {
        // auth: true,
      },
      component: () => import('./views/Bills.vue')
    },
    {
      path: '/financial_agenda',
      name: 'FinancialAgenda',
      meta: {
        // auth: true,
      },
      component: () => import('./views/FinancialAgenda.vue')
    },
    {
      path: '/litigations',
      name: 'Litigations',
      meta: {
        auth: true,
      },
      component: () => import('./views/Litigations.vue')
    },
    {
      path: '/financials',
      name: 'Financial',
      meta: {
        auth: true,
      },
      component: () => import('./views/Financial.vue')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      meta: {
        auth: true,
      },
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/settings',
      name: 'Settings',
      meta: {
        auth: true,
      },
      component: () => import('./views/Settings.vue'),
      // beforeEnter:requireAuth,
      children:[
        {
          path: 'employees',
          name: 'RegisterEmployees',
          component: () => import('./components/settings/Employees'),
        },
        {
          path: 'permissions',
          name: 'RegisterPermissions',
          component: () => import('./components/settings/Permissions'),
        }
      ]
    },
    {
      path: '/register',
      component: () => import('./views/Register.vue'),
      // meta: {
      //   auth: true,
      // },
      // children:[
      //   {
      //     path: 'clients',
      //     name: 'RegisterClients',
      //     // meta: {
      //     //   auth: true,
      //     // },
      //     // component: () => import(1/*'./views/RegisterClients.vue'*/),
      //     // children:[
      //     //   {
      //     //     path: 'special_sleeve',
      //     //     name: 'RegisterSpecialSleeve',
      //     //     component: () => import('./components/register/item/SpecialSleeve.vue'),
      //     //   },
      //     //   {
      //     //     path: 'code',
      //     //     name: 'RegisterCode',
      //     //     component: () => import('./components/register/item/Code.vue'),
      //     //   },
      //     // ]
      //   },
      //   // {
      //   //   path: 'suppliers',
      //   //   name: 'RegisterSuppliers',
      //   //   // meta: {
      //   //   //   auth: true,
      //   //   // },
      //   //   // component: () => import(2/*'./views/RegisterSuppliers'*/),
      //   // },
      // ]
    },
    
  ]
})

Vue.router = router;

export default router;
